"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddContextRequest = void 0;
var error_1 = require("./error");
var AddContextRequest = /** @class */ (function () {
    function AddContextRequest(_a) {
        var account = _a.account, displayName = _a.displayName, storageAccount = _a.storageAccount;
        this.account = account;
        this.displayName = displayName;
        this.storageAccount = storageAccount;
        if (!this.account || this.account.length !== 27) {
            throw new error_1.ValidationError("A request to add a context was generated. The request is rejected because the account must be a unique identifier of 27 characters.");
        }
    }
    return AddContextRequest;
}());
exports.AddContextRequest = AddContextRequest;
//# sourceMappingURL=addContextRequest.js.map